export const fileNegativeModal = (
	$uibModal,
	ctrl
) => async(
	entityId, 
	initialIndex, 
	multiplePeriods
) => {
	try {
		const instance = $uibModal.open({
			component: "negative-report-modal",
			size: "m",
			backdrop: "static",
			resolve: {
				form: () => ctrl.form,
				fields: () => ctrl.negativeFields,
				nomenclature: () => ctrl.form.nomenclature,
				periods: () => multiplePeriods,
				startPeriodIndex: () => initialIndex,
				entityId: () => entityId
			}
		});

		const result = await instance.result;

		return result;
	}
	catch(error) {		
		return undefined;
	}
};